import HTMLPage from './HTMLPage';
export default HTMLPage;